import * as React from "react";
import { forwardRef } from "react";
import { clsx } from 'clsx';
function _ModesVertCustom(props, ref) {
    const { className, ...rest } = props;
    const classes = clsx('go-icon', className);
    return React.createElement("span", { className: classes, ref: ref, ...rest },
        React.createElement("svg", { width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24" },
            React.createElement("path", { stroke: "currentColor", strokeLinecap: "round", d: "M12 17v4.5M12 2.5V7" }),
            React.createElement("circle", { cx: 12, cy: 12, r: 4.5, stroke: "currentColor" })));
}
const ModesVertCustom = forwardRef(_ModesVertCustom);
export { ModesVertCustom };
